import { DateTime } from 'luxon';

import { TimeSlot } from '../entities';
import { compareTimeArrays, toTimeArrayFromDate } from '../../utils';

export const isCurrentSlot = (slot: TimeSlot): boolean => {
  const now = toTimeArrayFromDate(DateTime.local());
  return compareTimeArrays(now, slot.startTime) && compareTimeArrays(slot.endTime);
};
